<template lang="pug">
el-config-provider(:locale="elementPlusLocale")
  SmxBaseLayout
    template(#navbar)
      Navbar(
        v-if="!isPublicPage",
        :post-logout="logoutCallback",
        title="",
        logo-path="/img/logo.svg",
        logo-path-small="/img/logo.svg",
        line-color="linear-gradient(90deg, #008CD4, #031c21)"
      )
    template(#menu)
      SmxMenu(v-if="!isPublicPage")
    .app-content(class="max-md:p-5 md:p-10")
      RouterView(:key="route.path")
</template>

<script setup lang="ts">
import { provide } from "vue";
import { RouterView, useRoute, useRouter } from "vue-router";
import Navbar from "@shared/components/Header.vue";
import { useAppStore } from "../../shared/src/stores/apps";
import SmxMenu from "@shared/components/SmxMenu.vue";
import { useMenuStore } from "../../shared/src/stores/menu";
import SmxBaseLayout from "@shared/views/SmxBaseLayout.vue";
import { useMyAccountStore } from "../../shared/src/stores/myAccount";
import { useKeyCloakAuthentication } from "../../shared/src/hooks/authentication";
import useMenu from "@shared/hooks/menu";
import { elementPlusLocale } from "@shared/util/languages";

const myAccountStore = useMyAccountStore();
useKeyCloakAuthentication();
const { isPublicPage } = useMenu();
useAppStore();
useMenuStore();
provide("assetTypeTitles", {
  "asset.produktion.pruefpflichtige-anlage": "inspectionRequiredFacilities",
  "asset.produktion.shopfloor": "productionLines",
});
const router = useRouter();
const route = useRoute();

const logoutCallback = () => {
  router.push({ name: "login" });
};
</script>

<style>
body {
  max-width: 100vw;
  overflow-x: hidden;
}

.app-body {
  display: flex;
}

.app-content {
  width: 100%;
}

:root {
  --el-color-primary: #008cd4;
}
</style>
